import { DisposableTokenType, exchangeToken } from '../../api/authorization/exchange-token';
import { storageKeys } from '../../utils/browser-storage/storage-keys';
import session from '../../utils/session';

type TokenType = 'download' | 'redirect';

const getDisposableToken = async (
    type: TokenType,
    access_token = window.storage.getItem(storageKeys.auth.accessToken),
    user_id = window.storage.getItem(storageKeys.user.userId)
): Promise<DisposableTokenType> => {
    if (type === 'download') {
        if (!session.isLoggedIn()) {
            return {
                access_token,
                token_type: 'Unauthorised'
            };
        }

        return exchangeToken({
            access_token,
            attributes: { user_id },
            scopes: ['download']
        });
    }

    return exchangeToken({
        access_token,
        attributes: { disposable: true, user_id },
        scopes: ['full']
    });
};

export default getDisposableToken;
